export enum CustomCodes {
  // Personalized
  DEVICE_PAIRING_FAILED = "DEVICE_PAIRING_FAILED",
  DEVICE_NOT_FOUND = "DEVICE_NOT_FOUND",
  INVALID_MONITORING = "INVALID_MONITORING",
  INVALID_BILLING = "INVALID_BILLING",
  INVALID_INVESTMENTS = "INVALID_INVESTMENTS",
  AC_PAIRING_FAILED = "AC_PAIRING_FAILED",

  WIFI_MEASUREMENT_FAILED = "WIFI_MEASUREMENT_FAILED",
  INTERNAL_PWA_ERROR = "INTERNAL_PWA_ERROR",

  // Generic form and interaction errors
  INVALID_FORM = "INVALID_FORM",
  INCOMPLETE_FORM = "INCOMPLETE_FORM",
  IMAGE_MISSING = "IMAGE_MISSING",
}

export type ErrorResponse = {
  code: string;
  message: string;
  description: string;
  cta: string;
};

export const CUSTOM_ERRORS_MAP: Record<CustomCodes, ErrorResponse> = {
  // unused
  DEVICE_PAIRING_FAILED: {
    code: "DEVICE_PAIRING_FAILED",
    message: "Erro de pareamento",
    description: "A conexão com o medidor inteligente falhou",
    cta: "Tentar novamente",
  },
  // unused
  DEVICE_NOT_FOUND: {
    code: "DEVICE_NOT_FOUND",
    message: "Dispositivo não encontrado",
    description: "O app não detectou o dispositivo físico",
    cta: "Verificar se o dispositivo está ligado",
  },
  // unused
  INVALID_MONITORING: {
    code: "INVALID_MONITORING",
    message: "Dados inválidos",
    description:
      "Você ainda não possui sistema solar fotovoltaico nem medidor inteligente cadastrado em nosso app.",
    cta: "Corrigir informações e reenviar",
  },
  // unused
  INVALID_BILLING: {
    code: "INVALID_BILLING",
    message: "Dados inválidos",
    description:
      "Os dados enviados da distribuidora estão incorretos ou com informações inválidas.",
    cta: "Corrigir informações e reenviar",
  },
  // unused
  INVALID_INVESTMENTS: {
    code: "INVALID_INVESTMENTS",
    message: "Dados inválidos",
    description: "Você ainda não possui dados de investimento. ",
    cta: "Corrigir informações e reenviar",
  },
  // unused
  AC_PAIRING_FAILED: {
    code: "AC_PAIRING_FAILED",
    message: "Falha no pareamento",
    description:
      "Não foi possível parear o ar-condicionado. Verifique se o controle está apontado para o aparelho e tente novamente.",
    cta: "Repetir pareamento",
  },
  INVALID_FORM: {
    code: "INVALID_FORM",
    message: "Erros no formulário",
    description: "O formulário contém informações inválidas",
    cta: "Tentar novamente",
  },
  INCOMPLETE_FORM: {
    code: "INCOMPLETE_FORM",
    message: "Erros no formulário",
    description: "Campos obrigatórios não foram preenchidos",
    cta: "Tentar novamente",
  },
  WIFI_MEASUREMENT_FAILED: {
    code: "WIFI_MEASUREMENT_FAILED",
    message: "Falha na detecção automática",
    description:
      "Seu aparelho não possui suporte para detecção automática de qualidade da wi-fi.",
    cta: "Cadastrar manualmente",
  },
  INTERNAL_PWA_ERROR: {
    code: "INTERNAL_PWA_ERROR",
    message: "Erro interno na consistência de dados",
    description:
      "Dados obrigatórios não estão sendo enviados. Reinicie a aplicação, e caso o problema persista, entre em contato com o suporte.",
    cta: "Fechar",
  },
  IMAGE_MISSING: {
    code: "IMAGE_MISSING",
    message: "Formulário incompleto",
    description: "Selecione uma imagem para continuar",
    cta: "Tentar novamente",
  },
};

export type MappedHttpCodes =
  | "400"
  | "401"
  | "403"
  | "404"
  | "408"
  | "409"
  | "410"
  | "429"
  | "500"
  | "502"
  | "503";

export const ERROR_ILLUSTRATIONS: Partial<
  Record<CustomCodes | MappedHttpCodes | "DEFAULT", string>
> = {
  DEVICE_PAIRING_FAILED: "/static/errorHandling/medidor.png",
  DEVICE_NOT_FOUND: "/static/errorHandling/medidor-antena.png",
  WIFI_MEASUREMENT_FAILED: "/static/errorHandling/code429.png",
  DEFAULT: "/static/errorHandling/code500.png",
  "400": "/static/errorHandling/code400.png",
  "401": "/static/errorHandling/code401.png",
  "403": "/static/errorHandling/code403.png",
  "404": "/static/errorHandling/code401.png",
  "408": "/static/errorHandling/code408.png",
  "409": "/static/errorHandling/code409.png",
  "410": "/static/errorHandling/code410.png",
  "429": "/static/errorHandling/code429.png",
  "500": "/static/errorHandling/code500.png",
  "502": "/static/errorHandling/code401.png",
  "503": "/static/errorHandling/code503.png",
};
